import PublicPage from "components/PublicPage";
import React from "react";

export default function AboutPage() {
  return (
    <PublicPage
      metadata={{
        title: "About Pipers For Hire",
        description:
          "Learn about Pipers For Hire – the marketplace for bagpipers in your area and a leading source of gigs for performers in the U.S.",
        url: "https://pipersforhire.com/about",
      }}
    >
      <h1 className="text-2xl font-bold text-theme-blue">About Us</h1>
      <p className="mt-6">
        The inspiration for Pipers For Hire originated when founder Jonas
        Pauliukonis found himself overbooked for piping gigs. Instead of
        politely declining gigs and leaving the client to restart their search
        process – he set out to connect those clients with other bagpiping
        friends and colleagues who were available. Pipers For Hire serves to
        recreate that experience by connecting clients with local freelance
        bagpipers.
      </p>
      <h2 className="mt-20 text-2xl font-bold text-theme-blue">
        What makes us unique
      </h2>
      <p className="mt-6">
        While so many &quot;gig&quot; sites are positioned as the one-stop-shop
        for everything from DJs and string quartets to wait staff and clowns,
        House of Piping is focused solely on promoting and showcasing the
        bagpiping community. Whether you&apos;re a client looking to hire a
        bagpiper or a piper looking for more business -- think of us as your
        guide along the way.
        <br />
        <br />
        The Pipers For Hire team has its roots in California&apos;s Silicon
        Valley but now operates out of Middle Tennessee. But while the team is
        local, our goal is to be the premier site for booking bagpipers
        throughout the world.
      </p>
    </PublicPage>
  );
}
